import React, { useState, useRef } from 'react';
import styles from './profilemenu.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerProfileThunk, setCustomerRefresh, setLoggedIn, upadteCustomerProfileThunk } from '../../../../Website/redux/customerSlice';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../../../../Website/utils/api';
import axios from 'axios';

const ProfileMenu = () => {
    const { customer } = useSelector(state => state.customer)
    const { notificationCountData } = useSelector(state => state.notification);
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation();
    const path = location.pathname
    const [showConfirm, setShowConfirm] = useState(false);
    const [uploading, setUploading] = useState(false);
    const imageRef = useRef();

    const handleImageChange = async (e) => {
        const file = e.target?.files?.[0];
        if (!file) return;

        setUploading(true);
        try {
            const body = {
                key: `${Date.now()}_${file.name}`,
                fileType: file.type,
                fileName: file.name,
            };

            const { data, status } = await api.getPutSignedUrl(body);

            if (status === 200) {
                await axios.put(data.data?.preSigned, file, {
                    headers: {
                        "Content-Type": file.type
                    }
                });

                const updatedValues = {
                    fullName: customer?.fullName || '',
                    email: customer?.email || '',
                    phone: customer?.phone || '',
                    companyName: customer?.companyName || '',
                    gstn: customer?.gstn || '',
                    profileImg: data?.data?.url
                };
                const result = await dispatch(upadteCustomerProfileThunk(updatedValues));
                if (result?.payload) toast.success("Profile photo updated");
            }
        } catch (err) {
            console.log(err);
            toast.error("Error uploading file");
        } finally {
            setUploading(false);
        }
    };

    const handleDeletePhoto = async () => {
        try {
            const updatedValues = {
                fullName: customer?.fullName || '',
                email: customer?.email || '',
                phone: customer?.phone || '',
                companyName: customer?.companyName || '',
                gstn: customer?.gstn || '',
                profileImg: ''
            };
            // The thunk shows its own error toast and resolves without data when the update fails
            const result = await dispatch(upadteCustomerProfileThunk(updatedValues));
            if (result?.payload) toast.success("Profile photo removed");
        } catch (err) {
            console.log(err);
            toast.error("Error removing profile photo");
        }
    };

    const logout = async () => {
        try {
            await localStorage.clear();
            dispatch(setLoggedIn(false))
            // dispatch(setCustomerRefresh())
            navigate('/')
            toast.success('Logged out successfully')
        }
        catch (err) {
            console.log(err);
            toast.error('something went wrong')
        }

    }

    const IsUserActive = path.startsWith('/accountusers') || path.startsWith('/ViewAccountUser') || path.startsWith('/editAccountUser')
    const isOrderHistoryActive = path.startsWith('/allOrders') || path.startsWith('/orderDetails')
    const isexessActive = path.startsWith('/ExcessStocks') || path.startsWith('/VendorExcessDetails')

    const avatarUrl = (!customer?.profileImg || customer.profileImg.includes('via.placeholder.com')) 
        ? '/assets/defaultUser.jpg' 
        : customer.profileImg;

    return (
        <>
            <div className={styles.profilebodyImage}>
                <div className={styles.avatarOverlay} onClick={() => imageRef.current.click()}>
                    <img
                        src={avatarUrl}
                        alt="User Avatar"
                        className={styles.avatar}
                    />
                    <div className={styles.overlayText}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                            <circle cx="12" cy="13" r="4"></circle>
                        </svg>
                    </div>
                </div>
                <strong>{customer?.fullName}</strong>
                <span>{customer?.userType}</span>
                
                <div style={{ display: 'flex', gap: '12px', marginTop: '10px' }}>
                    <input
                        type="file"
                        style={{ display: 'none' }}
                        ref={imageRef}
                        onChange={handleImageChange}
                        accept="image/*"
                    />
                    <button 
                        type="button" 
                        onClick={() => imageRef.current.click()}
                        disabled={uploading}
                        style={{
                            background: 'rgba(81, 45, 168, 0.06)',
                            border: 'none',
                            color: '#512da8',
                            fontSize: '11px',
                            fontWeight: '700',
                            cursor: 'pointer',
                            padding: '6px 12px',
                            borderRadius: '20px',
                            transition: 'all 0.2s ease',
                            outline: 'none'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = 'rgba(81, 45, 168, 0.12)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'rgba(81, 45, 168, 0.06)';
                        }}
                    >
                        {uploading ? '...' : 'Upload'}
                    </button>
                    {customer?.profileImg && !customer.profileImg.includes('via.placeholder.com') && (
                        <button 
                            type="button" 
                            onClick={handleDeletePhoto}
                            style={{
                                background: 'rgba(239, 68, 68, 0.06)',
                                border: 'none',
                                color: '#ef4444',
                                fontSize: '11px',
                                fontWeight: '700',
                                cursor: 'pointer',
                                padding: '6px 12px',
                                borderRadius: '20px',
                                transition: 'all 0.2s ease',
                                outline: 'none'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = 'rgba(239, 68, 68, 0.12)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'rgba(239, 68, 68, 0.06)';
                            }}
                        >
                            Delete
                        </button>
                    )}
                </div>
            </div>
            <div className={styles.profileMenu}>
                <h2 className={styles.profileheader}>Navigation</h2>
                <ul className={styles.profilemenuList}>
                    <li 
                        className={`${styles.profilemenuItem} ${(path.startsWith('/userNotifications') || path.startsWith('/vendorNotifications')) && styles.profileactive}`} 
                        onClick={() => navigate(customer?.userType === "VENDOR" ? "/vendorNotifications" : "/userNotifications")}
                    >
                        <span className={styles.profileicon}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
                                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                            </svg>
                        </span>
                        Notifications
                        {notificationCountData > 0 && (
                            <span style={{ marginLeft: 'auto', background: '#512DA8', color: '#fff', borderRadius: '10px', fontSize: '12px', fontWeight: 600, minWidth: '20px', height: '20px', padding: '0 6px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                {notificationCountData > 99 ? '99+' : notificationCountData}
                            </span>
                        )}
                    </li>
                    <li className={`${styles.profilemenuItem} ${path.startsWith('/myprofile') && styles.profileactive}`} onClick={() => navigate('/myprofile')}>
                        <span className={styles.profileicon}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21 21H13V15H21V21ZM11 21H3V11H11V21ZM21 13H13V3H21V13ZM11 9H3V3H11V9Z" fill="#1A1A1A" />
                            </svg>
                        </span>
                        Dashboard
                    </li>
                    <li className={`${styles.profilemenuItem} ${path.startsWith('/userEnquires') && styles.profileactive}`} onClick={() => navigate('/userEnquires')}>
                        <span className={styles.profileicon}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 20V13H11L7.783 16.22C8.33247 16.7819 8.98837 17.2287 9.71241 17.5343C10.4364 17.8399 11.2141 17.9983 12 18C13.2393 17.9982 14.4475 17.6127 15.4589 16.8965C16.4702 16.1802 17.2349 15.1684 17.648 14H17.666C17.78 13.675 17.867 13.34 17.925 13H19.937C19.6934 14.9333 18.7527 16.7111 17.2913 18C15.83 19.2888 13.9485 20 12 20H11.99C10.9398 20.0032 9.89944 19.798 8.9291 19.3963C7.95876 18.9946 7.07772 18.4045 6.337 17.66L4 20ZM6.074 11H4.062C4.30548 9.06751 5.24564 7.29019 6.70616 6.00145C8.16667 4.7127 10.0472 4.00108 11.995 4.00004H12C13.0504 3.99671 14.0909 4.20183 15.0615 4.6035C16.032 5.00517 16.9132 5.59541 17.654 6.34004L20 4.00004V11H13L16.222 7.78004C15.672 7.21752 15.0153 6.77035 14.2903 6.46471C13.5654 6.15907 12.7867 6.0011 12 6.00004C10.7607 6.00187 9.55246 6.38738 8.54114 7.10361C7.52982 7.81985 6.76508 8.83166 6.352 10H6.334C6.219 10.325 6.132 10.66 6.075 11H6.074Z" fill="#CCCCCC" />
                            </svg>
                        </span>
                        All Enquiries
                    </li>
                    {customer?.userType == "VENDOR" &&
                        <>
                            <li
                                className={`${styles.profilemenuItem} ${(path.startsWith('/receivedEnquires') || path.startsWith('/vendorEnquiryDetails')) && styles.profileactive}`}
                                onClick={() => navigate('/receivedEnquires')}
                            >
                                <span className={styles.profileicon}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 20V13H11L7.783 16.22C8.33247 16.7819 8.98837 17.2287 9.71241 17.5343C10.4364 17.8399 11.2141 17.9983 12 18C13.2393 17.9982 14.4475 17.6127 15.4589 16.8965C16.4702 16.1802 17.2349 15.1684 17.648 14H17.666C17.78 13.675 17.867 13.34 17.925 13H19.937C19.6934 14.9333 18.7527 16.7111 17.2913 18C15.83 19.2888 13.9485 20 12 20H11.99C10.9398 20.0032 9.89944 19.798 8.9291 19.3963C7.95876 18.9946 7.07772 18.4045 6.337 17.66L4 20ZM6.074 11H4.062C4.30548 9.06751 5.24564 7.29019 6.70616 6.00145C8.16667 4.7127 10.0472 4.00108 11.995 4.00004H12C13.0504 3.99671 14.0909 4.20183 15.0615 4.6035C16.032 5.00517 16.9132 5.59541 17.654 6.34004L20 4.00004V11H13L16.222 7.78004C15.672 7.21752 15.0153 6.77035 14.2903 6.46471C13.5654 6.15907 12.7867 6.0011 12 6.00004C10.7607 6.00187 9.55246 6.38738 8.54114 7.10361C7.52982 7.81985 6.76508 8.83166 6.352 10H6.334C6.219 10.325 6.132 10.66 6.075 11H6.074Z" fill="#CCCCCC" />
                                    </svg>
                                </span>
                                Received Enquiries
                            </li>
                            <li
                                className={`${styles.profilemenuItem} ${(path.startsWith('/receivedOrders') || path.startsWith('/receivedOrderdetails')) && styles.profileactive}`}
                                onClick={() => navigate('/receivedOrders')}
                            >
                                <span className={styles.profileicon}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 20V13H11L7.783 16.22C8.33247 16.7819 8.98837 17.2287 9.71241 17.5343C10.4364 17.8399 11.2141 17.9983 12 18C13.2393 17.9982 14.4475 17.6127 15.4589 16.8965C16.4702 16.1802 17.2349 15.1684 17.648 14H17.666C17.78 13.675 17.867 13.34 17.925 13H19.937C19.6934 14.9333 18.7527 16.7111 17.2913 18C15.83 19.2888 13.9485 20 12 20H11.99C10.9398 20.0032 9.89944 19.798 8.9291 19.3963C7.95876 18.9946 7.07772 18.4045 6.337 17.66L4 20ZM6.074 11H4.062C4.30548 9.06751 5.24564 7.29019 6.70616 6.00145C8.16667 4.7127 10.0472 4.00108 11.995 4.00004H12C13.0504 3.99671 14.0909 4.20183 15.0615 4.6035C16.032 5.00517 16.9132 5.59541 17.654 6.34004L20 4.00004V11H13L16.222 7.78004C15.672 7.21752 15.0153 6.77035 14.2903 6.46471C13.5654 6.15907 12.7867 6.0011 12 6.00004C10.7607 6.00187 9.55246 6.38738 8.54114 7.10361C7.52982 7.81985 6.76508 8.83166 6.352 10H6.334C6.219 10.325 6.132 10.66 6.075 11H6.074Z" fill="#CCCCCC" />
                                    </svg>
                                </span>
                                Received Orders
                            </li>
                        </>
                    }
                    <li
                        className={`${styles.profilemenuItem} ${(path.startsWith('/userSchedulePO') || path.startsWith('/schedulePoDetails')) && styles.profileactive}`}
                        onClick={() => navigate('/userSchedulePO')}
                    >
                        <span className={styles.profileicon}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 20V13H11L7.783 16.22C8.33247 16.7819 8.98837 17.2287 9.71241 17.5343C10.4364 17.8399 11.2141 17.9983 12 18C13.2393 17.9982 14.4475 17.6127 15.4589 16.8965C16.4702 16.1802 17.2349 15.1684 17.648 14H17.666C17.78 13.675 17.867 13.34 17.925 13H19.937C19.6934 14.9333 18.7527 16.7111 17.2913 18C15.83 19.2888 13.9485 20 12 20H11.99C10.9398 20.0032 9.89944 19.798 8.9291 19.3963C7.95876 18.9946 7.07772 18.4045 6.337 17.66L4 20ZM6.074 11H4.062C4.30548 9.06751 5.24564 7.29019 6.70616 6.00145C8.16667 4.7127 10.0472 4.00108 11.995 4.00004H12C13.0504 3.99671 14.0909 4.20183 15.0615 4.6035C16.032 5.00517 16.9132 5.59541 17.654 6.34004L20 4.00004V11H13L16.222 7.78004C15.672 7.21752 15.0153 6.77035 14.2903 6.46471C13.5654 6.15907 12.7867 6.0011 12 6.00004C10.7607 6.00187 9.55246 6.38738 8.54114 7.10361C7.52982 7.81985 6.76508 8.83166 6.352 10H6.334C6.219 10.325 6.132 10.66 6.075 11H6.074Z" fill="#CCCCCC" />
                            </svg>
                        </span>
                        Open Order
                    </li>
                    {customer?.userType == "VENDOR" &&
                        <li className={`${styles.profilemenuItem} ${isexessActive && styles.profileactive}`}
                            onClick={() => navigate('/ExcessStocks')}>
                            <span className={styles.profileicon}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 20V13H11L7.783 16.22C8.33247 16.7819 8.98837 17.2287 9.71241 17.5343C10.4364 17.8399 11.2141 17.9983 12 18C13.2393 17.9982 14.4475 17.6127 15.4589 16.8965C16.4702 16.1802 17.2349 15.1684 17.648 14H17.666C17.78 13.675 17.867 13.34 17.925 13H19.937C19.6934 14.9333 18.7527 16.7111 17.2913 18C15.83 19.2888 13.9485 20 12 20H11.99C10.9398 20.0032 9.89944 19.798 8.9291 19.3963C7.95876 18.9946 7.07772 18.4045 6.337 17.66L4 20ZM6.074 11H4.062C4.30548 9.06751 5.24564 7.29019 6.70616 6.00145C8.16667 4.7127 10.0472 4.00108 11.995 4.00004H12C13.0504 3.99671 14.0909 4.20183 15.0615 4.6035C16.032 5.00517 16.9132 5.59541 17.654 6.34004L20 4.00004V11H13L16.222 7.78004C15.672 7.21752 15.0153 6.77035 14.2903 6.46471C13.5654 6.15907 12.7867 6.0011 12 6.00004C10.7607 6.00187 9.55246 6.38738 8.54114 7.10361C7.52982 7.81985 6.76508 8.83166 6.352 10H6.334C6.219 10.325 6.132 10.66 6.075 11H6.074Z" fill="#CCCCCC" />
                                </svg>
                            </span>
                            Excess Inventory
                        </li>
                    }
                    <li
                        className={`${styles.profilemenuItem} ${isOrderHistoryActive && styles.profileactive}`}
                        onClick={() => navigate('/allOrders')}>
                        <span className={styles.profileicon}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 10H5L3 21H21L19 10H16M8 10V7C8 4.79086 9.79086 3 12 3V3C14.2091 3 16 4.79086 16 7V10M8 10H16M8 10V13M16 10V13" stroke="#CCCCCC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </span>
                        Order History
                    </li>
                    {customer?.userType == "USER" &&
                        <li
                            className={`${styles.profilemenuItem} ${IsUserActive && styles.profileactive}`}
                            onClick={() => navigate('/accountusers')}>
                            <span className={styles.profileicon}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2C9.24746 2 7 4.24746 7 7C7 9.75254 9.24746 12 12 12C14.7525 12 17 9.75254 17 7C17 4.24746 14.7525 2 12 2ZM12 3.5C13.9419 3.5 15.5 5.05812 15.5 7C15.5 8.94188 13.9419 10.5 12 10.5C10.0581 10.5 8.5 8.94188 8.5 7C8.5 5.05812 10.0581 3.5 12 3.5ZM5.98926 14C4.89935 14 4 14.8993 4 15.9893V16.75C4 18.5521 5.13963 19.9461 6.65332 20.7812C8.167 21.6164 10.0841 22 12 22C13.9159 22 15.833 21.6164 17.3467 20.7812C18.6373 20.0692 19.6087 18.9313 19.8809 17.5H20.001V15.9893C20.001 14.8993 19.1006 14 18.0107 14H5.98926ZM5.98926 15.5H18.0107C18.2898 15.5 18.501 15.7102 18.501 15.9893V16H18.5V16.75C18.5 17.9479 17.8271 18.8039 16.6221 19.4687C15.417 20.1336 13.7091 20.5 12 20.5C10.2909 20.5 8.58299 20.1336 7.37793 19.4687C6.17286 18.8039 5.5 17.9479 5.5 16.75V15.9893C5.5 15.7102 5.71016 15.5 5.98926 15.5Z" fill="#CCCCCC" />
                                </svg>
                            </span>
                            Users
                        </li>
                    }
                    <li className={styles.profilemenuItem} onClick={() => setShowConfirm(true)}>
                        <span className={styles.profileicon}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19 21H10C9.46957 21 8.96086 20.7893 8.58579 20.4142C8.21071 20.0391 8 19.5304 8 19V15H10V19H19V5H10V9H8V5C8 4.46957 8.21071 3.96086 8.58579 3.58579C8.96086 3.21071 9.46957 3 10 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21ZM12 16V13H3V11H12V8L17 12L12 16Z" fill="#CCCCCC" />
                            </svg></span>
                        Log-out
                    </li>
                </ul>
            </div>

            {showConfirm && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.65)',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999,
                    animation: 'fadeIn 0.2s ease-out'
                }}>
                    <div style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '16px',
                        padding: '30px',
                        width: '90%',
                        maxWidth: '380px',
                        textAlign: 'center',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                        transform: 'scale(1)',
                        animation: 'scaleUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
                    }}>
                        <div style={{
                            width: '56px',
                            height: '56px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(239, 68, 68, 0.08)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 20px auto'
                        }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                <polyline points="16 17 21 12 16 7"></polyline>
                                <line x1="21" y1="12" x2="9" y2="12"></line>
                            </svg>
                        </div>
                        
                        <h3 style={{
                            fontSize: '18px',
                            fontWeight: '700',
                            color: '#0f172a',
                            margin: '0 0 8px 0',
                            fontFamily: 'inherit'
                        }}>
                            Confirm Logout
                        </h3>
                        
                        <p style={{
                            fontSize: '14px',
                            color: '#64748b',
                            margin: '0 0 24px 0',
                            lineHeight: '1.5',
                            fontFamily: 'inherit'
                        }}>
                            Are you sure you want to log out? You will need to sign in again to access your account.
                        </p>
                        
                        <div style={{
                            display: 'flex',
                            gap: '12px',
                            justifyContent: 'center'
                        }}>
                            <button 
                                onClick={() => setShowConfirm(false)}
                                style={{
                                    flex: 1,
                                    padding: '12px 20px',
                                    borderRadius: '10px',
                                    border: '1px solid #e2e8f0',
                                    backgroundColor: '#ffffff',
                                    color: '#64748b',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    outline: 'none'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#f8fafc';
                                    e.target.style.color = '#0f172a';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#ffffff';
                                    e.target.style.color = '#64748b';
                                }}
                            >
                                Cancel
                            </button>
                            
                            <button 
                                onClick={() => {
                                    setShowConfirm(false);
                                    logout();
                                }}
                                style={{
                                    flex: 1,
                                    padding: '12px 20px',
                                    borderRadius: '10px',
                                    border: 'none',
                                    backgroundColor: '#ef4444',
                                    color: '#ffffff',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    outline: 'none',
                                    boxShadow: '0 4px 6px -1px rgba(239, 68, 68, 0.2)'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#dc2626';
                                    e.target.style.boxShadow = '0 6px 8px -1px rgba(239, 68, 68, 0.3)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#ef4444';
                                    e.target.style.boxShadow = '0 4px 6px -1px rgba(239, 68, 68, 0.2)';
                                }}
                            >
                                Log Out
                            </button>
                        </div>
                    </div>
                    <style>{`
                        @keyframes fadeIn {
                            from { opacity: 0; }
                            to { opacity: 1; }
                        }
                        @keyframes scaleUp {
                            from { transform: scale(0.95); opacity: 0; }
                            to { transform: scale(1); opacity: 1; }
                        }
                    `}</style>
                </div>
            )}
        </>
    );
};

export default ProfileMenu;
